import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import moment from 'moment';
import join from 'nllib/src/uri/join';

const open_page = function (pParameter) {
    if (!pParameter) pParameter = {};

    const htmlStr = pParameter.htmlStr;
    if (!htmlStr) {
        const msg = 'open_page parameter error, code=001';
        console.error(msg);
        return Q.reject({msg: msg});
    }

    const w = window.open(`about:blank`, `_blank`);
    w.document.write(htmlStr);

    return Q.resolve();
};

export default open_page;
